import { useCallback } from 'react';

import { IndicatorVariants } from '@formstack/phoenix/components/Indicator/constants';

import { useAppDispatch } from '@/store/app.hooks';

import { showToast } from './slice';

export const useToastNotification = () => {
  const dispatch = useAppDispatch();

  const showSuccessNotification = useCallback(
    (message: string) => {
      dispatch(showToast({ message, variant: IndicatorVariants.success }));
    },
    [dispatch]
  );

  const showErrorNotification = useCallback(
    (message: string) => {
      dispatch(showToast({ message, variant: IndicatorVariants.error }));
    },
    [dispatch]
  );

  return { showSuccessNotification, showErrorNotification };
};
